import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmSerialTypeForm from '../../../components/forms/FirearmSerialTypeForm';
import { useCreateFirearmSerialType } from '../../../hooks/useFirearmSerialTypeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmSerialTypeDTO } from '../../../services/apiClient';

const FirearmSerialTypeCreate: React.FC = () => {
  const createFirearmSerialType = useCreateFirearmSerialType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Serial Types', href: '/admin/firearmserialtypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: FirearmSerialTypeDTO) => {
    try {
      await createFirearmSerialType.mutateAsync(data);
      navigate('/admin/firearmserialtypes');
    } catch (error) {
      console.error('Error creating FirearmSerialType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmserialtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmSerialType.Edit'
    >
        <FirearmSerialTypeForm
          initialValues={{} as FirearmSerialTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/firearmserialtypes')}
        />
    </AdminLayout>
  );
};

export default FirearmSerialTypeCreate;